export default "__VITE_ASSET__BwOB5JRA__"